import {Outlet, createBrowserRouter} from "react-router-dom"
import {AppLayout} from "../layout"
import {
  Home,
  Profile,
  ProfileDetails,
  Error,
  ProfilePreferences,
} from "../pages"
import {ErrorBoundary} from "../components"
import FullPage from "../pages/Discover/FullPage"
import AccessDenied from "../pages/AccessDenied/AccessDenied"

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ErrorBoundary>
        <AppLayout>
          <Outlet />
        </AppLayout>
      </ErrorBoundary>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
        children: [
          {
            path: "/discover/:type/:name",
            element: <FullPage />,
          },
          {
            path: "/discover/:type/:subtype/:name",
            element: <FullPage />,
          },
        ],
      },
      {
        path: "/profile",
        element: <Profile />,
        children: [
          {
            path: "",
            element: <ProfileDetails />,
          },
          {
            path: "preferences",
            element: <ProfilePreferences />,
          },
        ],
      },
      {
        path: "*",
        element: <Error />,
      },
    ],
  },
  {
    path: "/access-denied",
    element: <AccessDenied />,
  },
  {
    path: "*",
    element: <Error />,
  },
])
export default router
